export const environment = {
  auth0: {
    audience: 'https://api-development.plantefeve-dev.be',
    clientId: 'Qmjd6FPrYH4pFdcZtBT85GozIMWVmPNC',
    domain: 'plantefeve-dev.eu.auth0.com',
    redirectUri: window.location.origin,
  },
  name: 'Plantefeve | Portal',
  production: false,
  serverApiUrl: 'https://plantefeve-dev-api.azurewebsites.net/',
};
